import {Typography} from 'antd';
import {ReactElement, useState} from 'react';

import {Locale} from '../../../../../../../../provider/locale/localization';
import {ReviewHistoryDataType} from '../../../../../../../../service/reviews/reviews-history';
import {PreviewGroup} from '../../preview-group/preview-group';
import {constructCommentPreview, extractReviewCommentContent} from '../../review-helper';

import * as styles from './history-modal.scss';

type PropsType = {
    value: ReviewHistoryDataType['oldValue'];
};

function toHistoryCommentText(value: ReviewHistoryDataType['oldValue']): string {
    return typeof value === 'string' ? value : '';
}

function toHistoryCommentContentValue(value: ReviewHistoryDataType['oldValue']): string | null {
    return typeof value === 'string' ? value : null;
}

export function HistoryExpandableComment(props: PropsType): ReactElement {
    const {value} = props;

    const [expanded, setExpanded] = useState<boolean>(false);

    return (
        <>
            <Typography.Paragraph
                ellipsis={{
                    rows: 3,
                    expandable: 'collapsible',
                    expanded,
                    onExpand: (_data, info) => setExpanded(info.expanded),
                    symbol: (
                        <Locale
                            stringKey={
                                expanded ? 'REVIEWS__REVIEW_ABUSE__HIDE_TEXT' : 'REVIEWS__REVIEW_ABUSE__SHOW_TEXT'
                            }
                        />
                    ),
                }}
            >
                {constructCommentPreview(toHistoryCommentText(value))}
            </Typography.Paragraph>
            <PreviewGroup
                imageClassName={styles.HistoryModal_previewImage}
                images={extractReviewCommentContent(toHistoryCommentContentValue(value))?.images}
                videos={extractReviewCommentContent(toHistoryCommentContentValue(value))?.videos}
            />
        </>
    );
}
